export default {"src":"/_next/static/media/check-box-checked.b17f756c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};